"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoaderMask = exports.TableContent = exports.TableArea = exports.TableRow = exports.Row = exports.Cell = exports.CellValue = exports.CellTitle = exports.StyledTable = exports.tableGutter = exports.tableBorder = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// These const attributes are only used by the dataGrid and thus have not been extracted to a higher level at this point in time
var tableBorder = (0, _styledComponents.css)(["", ";"], function (props) {
  return "".concat(props.theme.thinLine, " solid ").concat(props.withShadow ? props.theme.c_card_default_background : props.theme.c_background_alt);
});
exports.tableBorder = tableBorder;
var tableGutter = (0, _styledComponents.css)(["", ";"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}); // Begin standard pattern of exporting styled components

exports.tableGutter = tableGutter;

var StyledTable = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__StyledTable",
  componentId: "sc-1avgnwl-0"
})(["border:", ";border-radius:", ";background-color:", ";width:100%;", ";"], tableBorder, function (props) {
  return props.theme.borderRadius;
}, function (props) {
  return props.theme.c_background_default;
}, function (props) {
  return props.withShadow ? "box-shadow: ".concat(props.theme.s_card) : undefined;
});

exports.StyledTable = StyledTable;

var CellTitle = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__CellTitle",
  componentId: "sc-1avgnwl-1"
})(["display:inline-block;font-weight:", ";min-width:", ";width:", ";@media only screen and (min-width:", "){display:none;}"], function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.cardLeftContent;
}, function (props) {
  return props.theme.cardLeftContent;
}, function (props) {
  return props.theme.smallBreak;
});

exports.CellTitle = CellTitle;

var CellValue = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__CellValue",
  componentId: "sc-1avgnwl-2"
})(["display:contents;flex:none;"]);

exports.CellValue = CellValue;

var Cell = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__Cell",
  componentId: "sc-1avgnwl-3"
})(["align-items:center;display:flex;flex:1;min-height:", ";@media only screen and (min-width:", "){padding-left:", ";justify-content:", ";}"], function (props) {
  return props.theme.mediumButtonHeight;
}, function (props) {
  return props.theme.smallBreak;
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  switch (props.alignment) {
    case 'center':
      return 'center';

    case 'right':
      return 'flex-end';

    case 'left':
    default:
      return 'flex-start';
  }
});

exports.Cell = Cell;

var Row = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__Row",
  componentId: "sc-1avgnwl-4"
})(["display:flex;margin:0 ", ";padding-bottom:", ";padding-top:", ";@media only screen and (min-width:", "){padding-bottom:0;padding-top:0;}"], tableGutter, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.standardPadding;
}, function (props) {
  return props.theme.smallBreak;
});

exports.Row = Row;
var TableRow = (0, _styledComponents.default)(Row).withConfig({
  displayName: "DataGridstyles__TableRow",
  componentId: "sc-1avgnwl-5"
})(["border-bottom:", ";flex-direction:column;min-height:3rem;&:first-child{}&:last-child{border-bottom:none;}@media only screen and (min-width:", "){flex-direction:row;}"], tableBorder, function (props) {
  return props.theme.smallBreak;
});
exports.TableRow = TableRow;

var TableArea = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__TableArea",
  componentId: "sc-1avgnwl-6"
})(["width:100%;position:relative;"]);

exports.TableArea = TableArea;

var TableContent = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__TableContent",
  componentId: "sc-1avgnwl-7"
})(["", ";height:", ";"], function (props) {
  return props.isLoading ? 'filter: blur(3px)' : '';
}, function (props) {
  return props.hasData ? 'auto' : '10rem';
});

exports.TableContent = TableContent;

var LoaderMask = _styledComponents.default.div.withConfig({
  displayName: "DataGridstyles__LoaderMask",
  componentId: "sc-1avgnwl-8"
})(["align-items:center;background-color:", ";bottom:0;display:flex;justify-content:center;left:0;position:absolute;right:0;top:0;"], function (props) {
  return props.theme.c_mask_loader;
});

exports.LoaderMask = LoaderMask;